/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Type of the document
 */
export enum DocumentType {
  Pdf = 'pdf',
  Word = 'word',
  Excel = 'excel'
}
